import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

declare var $: any;

@Component({
  selector: 'zest-title-step',
  templateUrl: './title-step.component.html',
  styleUrls: ['./title-step.component.scss']
})

export class TitleStepComponent implements OnInit {

  @Input() mainTitle: string;
  @Input() smallNote: string;
  @Input() headerPic: string;
  @Input() downloadButtontext: string;
  @Input() additionalClass: string;
  @Input() marginTop: string;
  @Input() helpText: string;
  @Input() repaymentText: string;
  @Input() tooltip: string;
  @Input() modal: string;
  @Input() showOrderBanner: boolean;
  @Input() showMerchantLogo: boolean;
  @Input() message: string;
  @Input() merchantName: string;
  @Input() basketAmount: number;
  @Input() emi: number;
  @Input() emihelpText: string;
  @Input() isKyc = false;
  @Input() info: string;
  @Input() lenderDetailText: string;
  @Input() inPrincipleText: string;
  @Input() disbursalCompliance: string;
  @Output() modalStatus = new EventEmitter();
  @Output() startDownload = new EventEmitter();

  constructor() {
    this.dismiss = this.dismiss.bind(this);
  }

  ngOnInit() {
  }
  showModal() {
    this.modalStatus.emit('opened');
    $('#headerModal').modal('open');
  }
  closeModal() {
    $('#headerModal').modal('close');
  }
  dismiss() {
    this.modalStatus.emit('closed');
  }

  startSanctionLetterDownload($event) {
    $event.preventDefault();
    this.startDownload.emit($event);
  }
}
